import { useEffect, useState } from "react";
import { HalfMoon, SunLight } from "iconoir-react";

type Theme = "light" | "dark";

function initialTheme(): Theme {
  const painted = document.documentElement.dataset.theme;
  if (painted === "light" || painted === "dark") return painted;
  const stored = localStorage.getItem("nonogram:theme");
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(initialTheme);

  useEffect(() => {
    // boot.js has already set this before first paint; keep them in sync after a toggle.
    document.documentElement.dataset.theme = theme;
    try {
      localStorage.setItem("nonogram:theme", theme);
    } catch {
      // Theme preference can remain session-only when storage is unavailable.
    }
  }, [theme]);

  const nextTheme = theme === "light" ? "dark" : "light";
  return (
    <button
      className="theme-toggle"
      type="button"
      aria-label={`Use ${nextTheme} theme`}
      title={`Use ${nextTheme} theme`}
      onClick={() => setTheme(nextTheme)}
    >
      {theme === "light" ? (
        <HalfMoon className="theme-toggle-moon" width={20} height={20} strokeWidth={2} aria-hidden="true" />
      ) : (
        <SunLight width={20} height={20} strokeWidth={2} aria-hidden="true" />
      )}
    </button>
  );
}
